/** The pick reads' anyOf gate (salesOrderPick and the pick screen): editors hold picking:edit/commit/finish but not picking:view. */
export const SALES_ORDER_PICK_READ_PERMISSIONS = [
    'picking:view',
    'picking:edit',
    'picking:commit',
    'picking:finish',
];
//# sourceMappingURL=sales-order-pick-read-permissions.js.map